import { enableProdMode } from '@angular/core'
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic'

import { AppBrowserModule } from './app/app.browser.module'
import { environment } from './environments/environment'
import { prebootstrap } from './prebootstrap'

if (environment.production) {
  enableProdMode()
  start()
} else {
  main()
}

const test = document.getElementById('loading')

export function main(): Promise<any> {
  return platformBrowserDynamic().bootstrapModule(AppBrowserModule)
    .then(() => {
      console.log('Bootstrap success')

      const prebootstrapEl = document.getElementById('preboostrap')
      prebootstrapEl.className += ' loaded'

      // Remove the preboostrap element after the transition has completed
      setTimeout(() => {
        prebootstrapEl.remove()
      }, 2000)
    })
}

export function start() {
  const anim = prebootstrap('loading')
  let done = false

  const onEnterFrame = () => {
    if (anim.currentFrame >= 60 && !done) {
      done = true
      anim.removeEventListener('enterFrame', onEnterFrame)
      main()
    }
  }

  anim.addEventListener('enterFrame', onEnterFrame)
}




// WEBPACK FOOTER //
// C:/Users/florian.gadal/Workspace/cinenow-web/src/main.ts